export default __webpack_public_path__ + "static/media/gamepad-solid-hover.d841a1d4.svg";